// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"389":"7fde58ee","512":"f34b1dab","597":"ea7326fe","683":"b42df3ad","808":"47e6728b"}[chunkId] + ".chunk.css";
};